import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';

import { RequiredTripFieldSelect } from './RequiredTripFieldSelect';

export const PayerTripRequiredFieldSettings = () => {
  return (
    <div className="py-4">
      <FormFieldSet
        legend="Required Trip Fields"
        columns={4}
        Fields={
          <>
            <div>
              <RequiredTripFieldSelect
                label="Passenger Phone Number"
                name="passenger_phone_number"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="Passenger Weight"
                name="passenger_weight"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="Authorization ID"
                name="authorization_id"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="Insurance Policy ID"
                name="insurance_policy_id"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="Member ID"
                name="payer_passenger_external_id"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="External Trip ID"
                name="external_trip_id"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="Requested By Name"
                name="booked_by_name"
              />
            </div>
            <div>
              <RequiredTripFieldSelect
                label="Requested By Phone Number"
                name="booked_by_phone_number"
              />
            </div>
          </>
        }
      />
    </div>
  );
};
